"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _image = require("../../utils/image");
var _styles = _interopRequireDefault(require("./styles"));
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @jsxImportSource @emotion/react */

const Image = ({
  src,
  alt,
  blob,
  height,
  width,
  css,
  responsive,
  objectFit,
  radius,
  withPlaceholder,
  fallbackUrl,
  interactive,
  ...restProps
}) => {
  const [imageLoaded, setImageLoaded] = (0, _react.useState)(false);
  const [imageSrc, setImageSrc] = (0, _react.useState)(src || blob && (0, _image.convertBlobToObjectUrl)(blob) || undefined);
  const altText = (0, _react.useMemo)(() => {
    if (!imageLoaded && withPlaceholder) return 'Laster bilde...';
    if (!imageSrc) return 'Bilde ikke tilgjengelig';
    return alt;
  }, [imageLoaded, imageSrc, alt]);
  const handleLoad = () => {
    setImageLoaded(true);
  };
  const handleError = () => {
    setImageSrc(fallbackUrl);
    setImageLoaded(false);
  };
  return (0, _jsxRuntime.jsx)("img", {
    src: imageSrc,
    alt: altText,
    onLoad: withPlaceholder ? () => handleLoad() : undefined,
    onError: fallbackUrl ? () => handleError() : undefined,
    css: theme => [height && _styles.default.height(height), width && _styles.default.width(width), responsive && _styles.default.responsive, objectFit && _styles.default.objectFit(objectFit), withPlaceholder && !imageLoaded && _styles.default.placeholder(theme), radius && _styles.default.radius(radius), css && css],
    tabIndex: interactive ? 0 : undefined,
    role: interactive ? 'button' : undefined,
    ...restProps
  });
};
var _default = exports.default = Image;